<script setup lang="ts">
import type { NavColumn } from "~/composables/useContentRoute";

// Renders a list of <e-mega-menu-column>s (each a labelled group of links) for a
// mega-menu panel. Shared by MegaNavItem's flat-panel branch and its tabbed
// branch (a tab's body is just another set of columns), so the muted/lock,
// external-target, and view-all wiring lives in one place.
defineProps<{ columns: NavColumn[]; viewAllLabel?: string }>();

const isExternal = (path: string) => isExternalUrl(path);

// Fade + lock links whose target the visitor can't reach yet. Hosts are
// `display:contents`, so opacity must target the inner `part`, not the host.
const { isMuted } = useCanAccess();
</script>

<template>
  <e-mega-menu-column
    v-for="col in columns"
    :key="col.key"
    :label="col.label || undefined"
    :span="col.span ?? 1"
    :view-all="col.indexPath"
    :view-all-label="viewAllLabel || 'Read more'"
  >
    <e-mega-menu-link
      v-for="child in col.items"
      :key="child.slug"
      :to="child.path"
      :icon="isMuted(child.path) ? 'lock' : child.icon || undefined"
      :title="child.title"
      :description="child.description || undefined"
      :target="isExternal(child.path) ? '_blank' : undefined"
      :class="isMuted(child.path) ? 'part-[base]:opacity-60' : undefined"
    ></e-mega-menu-link>
  </e-mega-menu-column>
</template>
